export type FeatureIssueRule = {
  group: string;
  feature: string | null;
  label: string;
  red_count: number;
  yellow_count: number;
};

export type FeatureIssueSummary = {
  strategy: string;
  date: string;
  runner_count: number;
  rules: FeatureIssueRule[];
};

type PeriodIssueRule = FeatureIssueRule & {
  byDay: Record<string, { red: number; yellow: number }>;
};

export function periodFeatureIssues(summaries: FeatureIssueSummary[]) {
  const strategies = new Map<string, {
    strategy: string;
    runnersByDay: Record<string, number>;
    rules: Map<string, PeriodIssueRule>;
  }>();
  for (const summary of summaries) {
    const panel = strategies.get(summary.strategy) || {
      strategy: summary.strategy,
      runnersByDay: {} as Record<string, number>,
      rules: new Map<string, PeriodIssueRule>(),
    };
    panel.runnersByDay[summary.date] =
      (panel.runnersByDay[summary.date] || 0) + summary.runner_count;
    for (const rule of summary.rules) {
      const key = `${rule.group}\u0000${rule.feature || ""}`;
      const row = panel.rules.get(key) || {
        ...rule, red_count: 0, yellow_count: 0, byDay: {},
      };
      row.red_count += rule.red_count;
      row.yellow_count += rule.yellow_count;
      const day = row.byDay[summary.date] || { red: 0, yellow: 0 };
      day.red += rule.red_count;
      day.yellow += rule.yellow_count;
      row.byDay[summary.date] = day;
      panel.rules.set(key, row);
    }
    strategies.set(summary.strategy, panel);
  }
  return Array.from(strategies.values()).map((panel) => ({
    ...panel,
    rows: Array.from(panel.rules.values())
      .filter((rule) => rule.red_count || rule.yellow_count)
      .sort((left, right) => {
        const leftHasRed = left.red_count > 0;
        const rightHasRed = right.red_count > 0;
        if (leftHasRed !== rightHasRed) return leftHasRed ? -1 : 1;
        return right.red_count - left.red_count ||
          right.yellow_count - left.yellow_count || left.label.localeCompare(right.label);
      }),
  }));
}
